// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl } from "../utils/constants";

export const login = createAsyncThunk("login", async (payload) => {
    try {
        const config = {
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/json",
            },
        };

        const url = ApiBaseUrl;
        const response = await axios.post(url, payload, config);
        return response.data;
    } catch (error) {
        alert(error.response.data.message);
        throw error.response.data;
    }
});

const LoginSlice = createSlice({
    name: "loginReducer",

    initialState: {
        isLoading: false,
        data: null,
    },
    reducers: {
        clearLoginData: (state) => {
            state.data = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(login.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(login.fulfilled, (state, action) => {
                state.isLoading = false;
                state.data = action.payload;
            })
            .addCase(login.rejected, (state) => {
                state.isError = false;
            });
    },
});

export const { clearLoginData } = LoginSlice.actions;
export default LoginSlice.reducer;